import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UiLoadingService } from './ui-loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private uiLoadingService: UiLoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(this.uiLoadingService.showLoading());
  }
}
